<template>
  <el-dialog
    :title="$t('shopSms.purchaseSms')"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose">
    <div class="modal-body">
      <div class="ibox-content">
        <el-form :model="buyShopSmsInfo" label-width="120px">
          <el-form-item :label="$t('shopSms.unitPrice')">
            <el-input v-model="buyShopSmsInfo.smsPrice" disabled></el-input>
          </el-form-item>
          
          <el-form-item :label="$t('shopSms.purchaseQuantity')" prop="buyCount">
            <el-select
              v-model="buyShopSmsInfo.buyCount"
              style="width:100%"
              @change="computeSmsAmount"
              :placeholder="$t('shopSms.selectPurchaseQuantity')">
              <el-option disabled value="">{{ $t('shopSms.selectPurchaseQuantity') }}</el-option>
              <el-option value="100">100{{ $t('shopSms.unit') }}</el-option>
              <el-option value="200">200{{ $t('shopSms.unit') }}</el-option>
              <el-option value="500">500{{ $t('shopSms.unit') }}</el-option>
              <el-option value="1000">1000{{ $t('shopSms.unit') }}</el-option>
              <el-option value="2000">2000{{ $t('shopSms.unit') }}</el-option>
              <el-option value="5000">5000{{ $t('shopSms.unit') }}</el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('shopSms.paymentAmount')">
            <el-input v-model="buyShopSmsInfo.amount" disabled></el-input>
          </el-form-item>

          <el-form-item v-if="buyShopSmsInfo.qrCode" :label="$t('shopSms.paymentQrCode')">
            <div id="buySmsQrCodeDiv" style="width:200px; height:200px;"></div>
            <div>{{ buyShopSmsInfo.remark }}</div>
          </el-form-item>
        </el-form>

        <div class="ibox-content text-right">
          <el-button 
            type="warning" 
            style="margin-right:20px;" 
            @click="finishBuySms">
            {{ $t('shopSms.purchased') }}
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { computeSmsAmount } from '@/api/shop/shopSmsApi'
import { getShopId } from '@/api/shop/shopApi'
import QRCode from 'qrcodejs2'

export default {
  name: 'BuyShopSms',
  data() {
    return {
      dialogVisible: false,
      buyShopSmsInfo: {
        smsPrice: '',
        buyCount: '',
        amount: '0',
        qrCode: '',
        remark: ''
      }
    }
  },
  methods: {
    open(data) {
      this.resetForm()
      this.buyShopSmsInfo = { ...data }
      this.buyShopSmsInfo.shopId = getShopId()
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    resetForm() {
      this.buyShopSmsInfo = {
        smsPrice: '',
        buyCount: '',
        amount: '0',
        qrCode: '',
        remark: ''
      }
    },
    computeSmsAmount() {
      if (!this.validateForm()) {
        return
      }

      computeSmsAmount(this.buyShopSmsInfo).then(res => {
        if (res.code === 0) {
          this.buyShopSmsInfo = { ...res.data }
          this.$nextTick(() => {
            this.viewBuySmsQr()
          })
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    viewBuySmsQr() {
      document.getElementById("buySmsQrCodeDiv").innerHTML = ""
      new QRCode(document.getElementById("buySmsQrCodeDiv"), {
        text: this.buyShopSmsInfo.qrCode,
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.L
      })
    },
    finishBuySms() {
      this.handleClose()
      this.$emit('refresh')
    },
    validateForm() {
      if (!this.buyShopSmsInfo.buyCount) {
        this.$message.warning(this.$t('shopSms.selectPurchaseQuantityRequired'))
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
/* 样式与editShopSmsSwitch.vue保持一致 */
</style>